import React from "react";
import { PauseCircle } from "lucide-react";

export default function PortalPaused() {
  return (
    <div className="min-h-screen bg-background flex items-center justify-center p-6" data-testid="portal-paused-page">
      <div className="max-w-md text-center">
        <div className="h-14 w-14 rounded-2xl bg-primary/10 text-primary flex items-center justify-center mx-auto mb-5">
          <PauseCircle className="h-7 w-7" />
        </div>
        <h1 className="font-heading text-2xl font-bold">This portal is currently paused</h1>
        <p className="text-muted-foreground mt-3">
          Please contact <span className="font-medium text-foreground">Marlene Alesna</span> at{" "}
          <a href="tel:8089896741" className="text-primary font-medium">808-989-6741</a> if you have questions.
        </p>
      </div>
    </div>
  );
}
